import { toast, TypeOptions } from 'react-toastify';

interface CustomToastProps {
  title: string;
  content: string;
  type?: TypeOptions;
}
export function customToast({
  title,
  content,
  type = 'info',
}: Readonly<CustomToastProps>) {
  toast(
    <div>
      <span className='font-bold'>{title}</span>
      <p className='text-sm'>{content}</p>
    </div>,
    {
      type,
    },
  );
}
